import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import filterProducts from 'utils/attributes/filterProducts';
import getSpecifiedAttributes from 'utils/attributes/getSpecifiedAttributes';
import removeAttribute from 'utils/attributes/reomveAttribute';
import setAttributeValue from 'utils/attributes/setAttributeValue';
import getProductAttributes from '../selector/getProductAttributes';
import getProductItems from '../selector/getProductItems';
import getProductPageSelectors from '../selector/getProductPageSelectors';
import getProductType from '../selector/getProductType';
import { setProductIdAction } from '../slice';
import { ProductType, STOCK_STATUS } from '../types';

const setBestMatchingProductIdForAttributeOperation =
  (typeName: string, value: string, defaultProductId: number) =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const productPageSelectors = getProductPageSelectors(store);
    const productType = getProductType(store);
    const productPageAttributeList = productPageSelectors.map((selector) => selector.typeName);
    const allProductAttributes = getProductAttributes(store);
    let importantProductAttributes = getSpecifiedAttributes(productPageAttributeList, allProductAttributes);

    importantProductAttributes = setAttributeValue(importantProductAttributes, typeName, value);
    const allProducts = getProductItems(store);
    const availableProducts =
      productType === ProductType.personalized
        ? (allProducts as any).filter(
            (product: any) => product.product.avalilabilityStatus?.status !== STOCK_STATUS.STATUS_UNAVAILABLE,
          )
        : allProducts;
    let bestMatchingProducts = filterProducts(availableProducts as any[], importantProductAttributes);

    // if not matching products found, select matching product removed attributes one by one, except the one which just was set
    if (!bestMatchingProducts.length) {
      const attributesToRemove = importantProductAttributes.filter((attr) => attr.typeName !== typeName);
      attributesToRemove.some((attrToRemove) => {
        importantProductAttributes = removeAttribute(importantProductAttributes, attrToRemove.typeName);
        bestMatchingProducts = filterProducts(availableProducts as any[], importantProductAttributes);
        return bestMatchingProducts.length > 0;
      });
      // if not matching products found, select products only by just modified attribute
      // simplified version
      // importantProductAttributes = setAttributeValue([], typeName, value);
      // bestMatchingProducts = filterProducts(allProducts as any[], importantProductAttributes);
    }
    const productId = bestMatchingProducts.length ? bestMatchingProducts[0].product.productId : defaultProductId;

    dispatch(setProductIdAction(productId));
  };

export default setBestMatchingProductIdForAttributeOperation;
